import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Caixa de informação azul, para explicar o que uma janela vai fazer.
 *
 * ─── PORQUE EXISTE ──────────────────────────────────────────────────────────
 *
 * Este aspeto já era usado nas páginas de Configurações, mas escrito à mão com
 * estilos em linha em cada uma. Quando isso passa de três ou quatro sítios, as
 * cópias começam a divergir — uma com mais margem, outra com outro azul — e o
 * ecrã deixa de parecer o mesmo produto.
 *
 * ─── PARA QUE SERVE, E PARA QUE NÃO SERVE ───────────────────────────────────
 *
 * Serve para dizer, ANTES de a pessoa carregar no botão, o que a operação vai
 * provocar do outro lado — o que fica criado, o que fica lançado, o que ainda
 * dá para corrigir depois. É o tipo de coisa que se aprende por tentativa e
 * erro, e que não devia ser preciso aprender assim.
 *
 * Não serve para avisos de perigo nem para erros: esses são vermelhos e têm de
 * se distinguir de longe de uma explicação.
 *
 * @param {string} titulo    cabeçalho curto, opcional
 * @param {node}   children  o texto, tipicamente um <ul> de pontos
 */
const NotaInformativa = ({ titulo, children, style }) => (
  <div
    style={{
      backgroundColor: "#e3f2fd",
      border: "1px solid #90caf9",
      borderRadius: "8px",
      padding: "14px 18px",
      display: "flex",
      gap: "14px",
      alignItems: "flex-start",
      ...style,
    }}
  >
    <InfoOutlinedIcon
      style={{ color: "#1976d2", marginTop: "2px", flexShrink: 0 }}
    />
    <div style={{ fontSize: "14px", color: "#1565c0", lineHeight: "1.6" }}>
      {titulo && (
        <strong
          style={{ display: "block", marginBottom: "6px", fontSize: "15px" }}
        >
          {titulo}
        </strong>
      )}
      {children}
    </div>
  </div>
);

export default NotaInformativa;
